import { useEffect, useState } from 'react';
import { getPullRequestsLabels } from 'common/services/pull-requests.service';
import _ from 'lodash';

export const usePullRequestLabels = () => {
  const [pullRequestLabels, setPullRequestLabels] = useState([]);

  useEffect(() => {
    const fetchLabels = async () => {
      const prLabels = await getPullRequestsLabels();
      setPullRequestLabels(_.uniq(prLabels));
    };
    fetchLabels();
  }, []);

  return {
    pullRequestLabels
  };
};
